/*
 * Navigation indicator for connection status and cross-tab sharing mode.
 * Used by AppNavigation to show transport changes without rebuilding the navigation.
 * Subscribes to the shared stream services and announces the resulting status label.
 * Example: registerComponents(registry);
 *          <ConnectionStatus context={context}/>
 */

import { UIElement, defineUIElements } from '../../runtime/components/ui-element.js';
import { Icon } from '../../runtime/components/presentation.jsx';
import { connectionInfo } from './connection-status.js';

export class ConnectionStatus extends UIElement {
  static properties = { status: { state: true }, mode: { state: true } };

  constructor() {
    super();
    this.status = 'initializing';
  }

  updated(changed) {
    super.updated(changed);
    if (!this.context || !this.connection || this.subscribedTo === this.connection) return;
    this.subscribedTo = this.connection;
    const store = this.context.services.state;
    const publish = this.connection.guard(() => {
      this.status = store.get('conn.status');
      this.mode = store.get('conn.mode');
    });
    this.connection.own(store.subscribe('conn.status', publish));
    this.connection.own(store.subscribe('conn.mode', publish));
    publish();
  }

  render() {
    const info = connectionInfo(this.status, this.mode);
    const label = info.message || 'Connection status';
    return (
      <span id="conn-status-indicator" class="conn-status-container" role="img" aria-label={label} title={label}>
        <Icon
          name="status-dot"
          classes={`conn-status-dot ${info.color}${info.pulse ? ' is-pulsing' : ''}`}
          focusable={false}/>
      </span>
    );
  }
}

export function registerComponents(registry) {
  defineUIElements(registry, { 'tbc-connection-status': ConnectionStatus });
}
